module.exports = __webpack_public_path__ + "img/database-gray.d7e65132.svg";